/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DashboardInputs */

const en_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const es_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const fr_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

const de_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ja_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボード`)
};

const zh_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仪表板`)
};

const ar_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة التحكم`)
};

const id_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor`)
};

const it_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ru_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления`)
};

const pt_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel`)
};

const ko_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dashboard = /** @type {((inputs?: DashboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DashboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard(inputs)
	if (locale === "es") return es_dashboard(inputs)
	if (locale === "fr") return fr_dashboard(inputs)
	if (locale === "de") return de_dashboard(inputs)
	if (locale === "ja") return ja_dashboard(inputs)
	if (locale === "zh") return zh_dashboard(inputs)
	if (locale === "ar") return ar_dashboard(inputs)
	if (locale === "id") return id_dashboard(inputs)
	if (locale === "it") return it_dashboard(inputs)
	if (locale === "ru") return ru_dashboard(inputs)
	if (locale === "pt") return pt_dashboard(inputs)
	return ko_dashboard(inputs)
});